import * as React from "react";

const RightArrowExtendedIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#F8FAFC"
            d="M24.175 21H12v-2h12.175l-5.6-5.6L20 12l8 8-8 8-1.425-1.4z"
        ></path>
    </svg>
);

export default RightArrowExtendedIconSVG;
